module.exports = __webpack_public_path__ + "static/media/6.d4189f89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6.jpg
// module id = 507
// module chunks = 0